<template>
  <div class="app">
    <router-view />
  </div>
</template>

<style lang="scss" scoped>
.app {
  width: 100vw;
  height: 100vh;
  // background-color: #020308;
  // background-color: #1D2B4B;
  background-color: #0A0028;
  overflow: hidden;
}
</style>
